module.exports = __webpack_public_path__ + "img/Search-rafiki.a6d530a2.png";